import { jsxs as d, jsx as n } from "react/jsx-runtime";
import D, { useState as _, useRef as h, useEffect as f } from "react";
import { f as y } from "../../format-DF9p-6BI.mjs";
import { classes as W } from "../../utils/helpers.js";
import { C as L } from "../../chevron-left-DmvQntvu.mjs";
import { C as E } from "../../chevron-right-CaAz6ISN.mjs";
import '../../assets/DateNavigation.css';const e = {
  "date-navigation__list": "_date-navigation__list_18gb9_5",
  "date-navigation__control": "_date-navigation__control_18gb9_42",
  "date-navigation__control--previous": "_date-navigation__control--previous_18gb9_69",
  "date-navigation__control--next": "_date-navigation__control--next_18gb9_74",
  "date-navigation__day": "_date-navigation__day_18gb9_94",
  "date-navigation__month-day-break": "_date-navigation__month-day-break_18gb9_100"
};
function $({ weeks: a = [[], []], handleDateChanged: s = () => !0 }) {
  const [i, b] = _(0), [p, k] = _(a[0]), [x, u] = _(a[0][0]), [N, v] = _("entering"), o = h(null), r = h(0), g = (t) => {
    b(t), v(() => t ? "exiting" : "entering");
  }, C = (t) => {
    u(t), s(t.date);
  }, S = (t) => {
    (t.key === "ArrowRight" || t.key === "ArrowDown") && r.current < 6 && ++r.current, (t.key === "ArrowLeft" || t.key === "ArrowUp") && r.current > 0 && --r.current, t.currentTarget.children[r.current].children[0].focus();
  }, l = D.useCallback(() => {
    o.current.addEventListener("animationstart", () => {
      o.current.addEventListener("animationend", l, { once: !0 });
    }), v("idle");
  }, []);
  return f(() => {
    o.current !== null && (o.current.removeEventListener("animationend", l, { once: !0 }), o.current.addEventListener("animationend", l, { once: !0 }));
  }, [l]), f(() => {
    k(a[i]), u((t) => {
      var m;
      const c = a[i ? 0 : 1].findIndex((j) => y(j.date, "yyyy-MM-dd") === y(t.date, "yyyy-MM-dd"));
      return c === -1 ? t : (s((m = a[i][c]) == null ? void 0 : m.date), r.current = c, a[i][c]);
    });
  }, [i, a, s]), /* @__PURE__ */ d("date-navigation", { "data-state": N, children: [
    /* @__PURE__ */ d("date-navigation-controls", { children: [
      /* @__PURE__ */ d(
        "button",
        {
          type: "button",
          className: [
            e["date-navigation__control"],
            e["date-navigation__control--previous"],
            "date-navigation__control",
            "date-navigation__control--previous"
          ].join(" "),
          onClick: () => {
            g(0);
          },
          disabled: i === 0 ? !0 : null,
          children: [
            /* @__PURE__ */ n("i", { "aria-hidden": "true", children: /* @__PURE__ */ n(L, { width: 48, height: 48 }) }),
            /* @__PURE__ */ n("span", { className: "sr-only", children: "Current Week" })
          ]
        }
      ),
      /* @__PURE__ */ d(
        "button",
        {
          type: "button",
          className: [
            e["date-navigation__control"],
            e["date-navigation__control--next"],
            "date-navigation__control",
            "date-navigation__control--next"
          ].join(" "),
          onClick: () => {
            g(1);
          },
          disabled: i === 1 ? !0 : null,
          children: [
            /* @__PURE__ */ n("i", { "aria-hidden": "true", children: /* @__PURE__ */ n(E, { width: 48, height: 48 }) }),
            /* @__PURE__ */ n("span", { className: "sr-only", children: "Next Week" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ n("date-navigation-list", { children: /* @__PURE__ */ n(
      "ul",
      {
        className: [e["date-navigation__list"], "date-navigation__list"].join(" "),
        ref: o,
        role: "tablist",
        "aria-label": "Date Tabs",
        onKeyDown: S,
        children: p.map((t) => /* @__PURE__ */ n("li", { className: [e["date-navigation__item"], "date-navigation__item"].join(" "), role: "presentation", children: /* @__PURE__ */ d(
          "button",
          {
            type: "button",
            className: [e["date-navigation__day"], "date-navigation__day"].join(" "),
            "aria-selected": x.fullDateStr === t.fullDateStr,
            onClick: () => {
              C(t);
            },
            role: "tab",
            "aria-controls": `${t.fullDateStr}`,
            children: [
              /* @__PURE__ */ n("div", { className: [e["date-navigation__weekday"], "date-navigation__weekday"].join(" "), children: t.dayStr }),
              /* @__PURE__ */ d("div", { className: [e["date-navigation__date"], "date-navigation__date"].join(" "), children: [
                t.monthStr,
                " ",
                /* @__PURE__ */ n("br", { className: W([e["date-navigation__month-day-break"], "date-navigation__month-day-break"]) }),
                t.dateStr
              ] })
            ]
          }
        ) }, `schedule-nav-${t.fullDateStr}`))
      }
    ) })
  ] });
}
export {
  $ as DateNavigation,
  $ as default
};
